module.exports = __webpack_public_path__ + "img/halo.5da3bbf.webp";